import { useState } from 'react';
import { Button } from '@mui/material';
import { RemoveRedEyeOutlined } from '@mui/icons-material';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import { IManageTool } from '../../../utils/entities/interface';
import { ListTable } from '../../molecules/ListTable';
import { ToggleToolStatus } from '../../../services/managetool';
import { DialogBoxComp } from '../../atoms/DialogBox';

export const ToolList = ({
  toolList,
  isLoading,
  headerCells,
  setAddToolModal,
  setFormData,
  onUpdate,
}: {
  toolList: IManageTool[];
  isLoading: boolean;
  headerCells: [string, number][];
  setAddToolModal: any;
  setFormData: any;
  onUpdate: () => void;
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedTool, setSelectedTool] = useState<IManageTool | null>(null);

  const handleOpenModal = (tool: IManageTool) => {
    setSelectedTool(tool);
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
    setSelectedTool(null);
  };

  const handleConfirmToggle = async () => {
    if (!selectedTool) return;
    await ToggleToolStatus(selectedTool._id);
    onUpdate();
    handleClose();
  };

  const actions = [
    // {
    //   icon: <RemoveRedEyeOutlined />,
    //   onClick: (row: IManageTool) => window.open(`/manage/services/${row._id}`),
    // },
    {
      icon: <BorderColorOutlinedIcon />,
      onClick: (row: IManageTool) => {
        setAddToolModal(true);
        setFormData({
          id: row._id,
          name: row.name,
          code: row.code || '',
          description: row.description,
          image: row.image,
          active: row.active,
        });
      },
    },
  ];

  return (
    <>
      <ListTable
        headerCells={headerCells}
        rows={toolList}
        isLoading={isLoading}
        actions={actions}
        renderCell={(tool: IManageTool, colIndex: number) => {
          switch (colIndex) {
            case 0:
              return (
                <span className="w-full h-full flex justify-center">
                  <img
                    src={tool.image}
                    className="w-[42px] h-[42px] rounded-full"
                  />
                </span>
              );
            case 1:
              return tool.name;
            case 2:
              return tool.code || '--';
            case 3:
              return tool.description;
            case 4:
              return (
                <Button
                  variant="outlined"
                  size="small"
                  color={tool.active ? 'error' : 'success'}
                  onClick={() => handleOpenModal(tool)}
                  sx={{
                    textTransform: 'none',
                    fontSize: '0.8rem',
                    borderRadius: '8px',
                  }}
                >
                  {tool.active ? 'Disable' : 'Enable'}
                </Button>
              );
            default:
              return null;
          }
        }}
      />

      <DialogBoxComp
        open={openModal}
        title={selectedTool?.active ? 'Disable Tool' : 'Enable Tool'}
        content={`Are you sure you want to ${selectedTool?.active ? 'disable' : 'enable'} "${selectedTool?.name}"?`}
        handleClose={handleClose}
        handleConfirm={handleConfirmToggle}
      />
    </>
  );
};
